import { Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import type { ChatMessageStatus } from "web_myplann/Chat/Types/chatMessage";

type Props = {
	children: ReactNode;
	alignment: "start" | "end";
	startAdornment?: ReactNode;
	status?: ChatMessageStatus;
};

export const ChatMessageBubble: FC<Props> = ({
	children,
	alignment,
	startAdornment,
	status,
}) => {
	const { message } = useTheme().chat;
	const flexAlignment = alignment === "end" ? "flex-end" : "flex-start";

	return (
		<Stack direction="row" justifyContent={flexAlignment}>
			{startAdornment}

			<Stack
				maxWidth={message.maxWidth}
				alignItems={flexAlignment}
				gap={message.gap}
				sx={{
					opacity: status === undefined ? 1 : message.pendingOpacity,
				}}
			>
				{children}
			</Stack>
		</Stack>
	);
};
